import { format, parse } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';

export const formatCurrency = (value: number | bigint): string =>
  new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    style: 'currency',
    currency: 'BRL',
  }).format(value);

export const formatPercentage = (value?: number) =>
  new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 0,
    style: 'percent',
  }).format(value || 0);

export const formatShortDate = (value: string) =>
  format(new Date(value), "'Dia' dd/MM", { locale: ptBR });

export const formatShortDatetime = (value: string) =>
  format(new Date(value), "'Dia' dd/MM 'às' HH'h'", { locale: ptBR });

// TODO: checar porque está havendo diferença de informação se comparado com a função em import { formatDate } from 'src/legacy/Utils/Conversor';
export const formatDatetime = (value: string) =>
  format(new Date(value), 'dd/MM/yyyy - HH:ss', { locale: ptBR });

export const formatDateToApi = (value: string) =>
  format(parse('', '', new Date(value)), 'yyyy-dd-MM', { locale: ptBR });

export function getValidatedLogoSrc(
  logoOrganizerPage: string | undefined,
): string {
  if (!logoOrganizerPage) {
    return '';
  }
  const isLink = logoOrganizerPage?.startsWith('https');
  const unicId = Date.now();

  if (isLink) {
    return `${logoOrganizerPage}?uniqueId=${unicId}`;
  } else {
    return `data:image/png;charset=utf-8;base64,${logoOrganizerPage}`;
  }
}
